import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login-screen');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-sm border-b border-border">
      <div className="flex items-center justify-between h-16 px-4 sm:px-6 max-w-7xl mx-auto">
        {/* Logo Section */}
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
            <Icon name="Brain" size={20} color="white" />
          </div>
          <span className="text-xl font-semibold text-foreground">MycoMind</span>
        </div>

        {/* Back to Login */}
        <Button
          variant="ghost"
          onClick={handleBackToLogin}
          iconName="ArrowLeft"
          iconPosition="left"
          className="text-sm"
        >
          Back to Login
        </Button>
      </div>
    </header>
  );
};

export default RegistrationHeader;